<template>
  <nav class="menu-top" v-if="items">
    <div class="menu-top__items">
      <template v-for="item in items">
        <a class="menu-top__item" v-if="item.openIsNewTab" :href="item.link"
                                         :key="item.id" target="_blank">
        <div class="menu-top__item-circle"></div>
        {{ item.title }}</a>
        <a class="menu-top__item" v-else="v-else" :href="item.link" :key="item.id">
          <div class="menu-top__item-circle"></div>
          {{ item.title }}
        </a>
      </template>
    </div>
  </nav>
</template>

<script>

export default {
  name: 'MenuTop',

  props: {
    items: {
      type: Array,
      required: true,
      default: null
    }
  }
}
</script>
